import { Product, ProductPostingMode } from '@mews-commander/data-access';

export const checkIsDateTimeVisible = (selectedProductId: string | undefined, serviceProducts: Product[]): boolean => {
    if (!selectedProductId) return false;
    const product = serviceProducts.find((p) => p.id === selectedProductId);
    if (!product) return false;
    return product.postingMode !== ProductPostingMode.PerTimeUnit;
};
